import React, { Fragment, useContext, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { api, Category, CategoryType, Distribution, ICategoryList, IDistributionList } from "../../../../../logic/api";
import { PagedDataView } from "../../../../lists/PagedDataView/PagedDataView";

import flex from "../../../../../styles/flex";
import { FiPlus } from "react-icons/fi";
import DistributionListItem from "../../../../lists/listItems/DistributionListItem/DistributionListItem";
import DistributionCategoryListItem from "../../../../lists/listItems/DistributionCategoryListItem/DistributionCategoryListItem";

import DistributionListCategoryDialog from "./DistributionListCategoryDialog";
import RecipientDialog from "./RecipientDialog";
import { SessionContext } from "../../../../../utility/useSession";
import { useTranslation } from "react-i18next";

const DistributionListField: React.FunctionComponent<{
    label: string,
    value?: Category;
    manageOnly?: boolean;
    testId?: string;
    onChange: (value: Category) => void;
}> = (props) => {
    const [showDialog, setShowDialog] = useState(false);

    const [distListParams, setDistListParams] = useState<ICategoryList>({ type: CategoryType.distribution, });
    const [distCatParams, setDistCatParams] = useState<IDistributionList>({});

    const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);
    const [selectedRecipient, setSelectedRecipient] = useState<Distribution | null>(null);
    const [showDistributionListCategoryDialog, setShowDistributionListCategoryDialog] = useState(false);
    const [showRecipientDialog, setShowRecipientDialog] = useState(false);

    const session = useContext(SessionContext);
    const link = api.hooks.distribution.link();
    const { t } = useTranslation();

    const linkRecipient = (recipient: Distribution) => {
        if (selectedCategory == null) return;
        link.send(session.current.context, {
            distributionId: recipient.id == null ? 0 : recipient.id,
            categoryId: selectedCategory.id,
        }, () => {
            setDistCatParams({ ...distCatParams });
        });
    }

    const fieldText = props.value != null ? `${props.value.categoryName}` : `Select`;

    return (
        <div>


            <Dialog fullWidth={true} maxWidth={"md"} open={showDialog}>
                <DialogTitle>{t("settings.distributionLists")}</DialogTitle>
                <DialogContent>

                    <div style={flex.flexRows}>
                        <div style={flex.flexAuto}>
                            <IconButton
                                onClick={() => {
                                    setSelectedCategory(null);
                                    setShowDistributionListCategoryDialog(true);
                                }}
                            >
                                <FiPlus />
                            </IconButton>
                        </div>
                        <div style={{ ...flex.flexAuto, width: 200 }}>

                            <div style={{ paddingTop: 12 }}>{t("editable.createList")}</div>
                        </div>

                        {selectedCategory != null && (<Fragment>
                            <div style={flex.flexAuto}>
                                <IconButton
                                    onClick={() => {
                                        setSelectedRecipient(null);
                                        setShowRecipientDialog(true);
                                    }}
                                >
                                    <FiPlus />
                                </IconButton>
                            </div>

                            <div style={flex.flexFill}>
                                <div style={{ paddingTop: 12 }}>{t("editable.recipient")}</div>
                            </div>



                        </Fragment>)}


                    </div>
                    <div style={flex.flexRows}>
                        <div style={{ ...flex.flexAuto, width: 250 }}>
                            <div style={{ marginRight: 10 }}>
                                <DistributionListCategoryDialog selected={selectedCategory} show={showDistributionListCategoryDialog} onClose={(didUpdate, category) => {
                                    if (didUpdate == true) {
                                        setSelectedCategory(category);
                                        setDistCatParams({ ...distCatParams, categoryId: category == null ? 0 : category.id });
                                        setDistListParams({ ...distListParams });

                                    }
                                    setShowDistributionListCategoryDialog(false);
                                }} />
                                <PagedDataView<ICategoryList, Category>
                                    apiHook={api.hooks.category.list}
                                    parameters={distListParams}

                                    renderItem={(item) => {
                                        const isSelected = selectedCategory != null && selectedCategory.id == item.id;
                                        return <DistributionCategoryListItem selected={isSelected} item={item} onEdit={() => {
                                            if (isSelected == false) {
                                                setSelectedCategory(item);
                                                setDistCatParams({
                                                    categoryId: item.id,
                                                });
                                            }


                                            setShowDistributionListCategoryDialog(true);
                                        }} onClick={() => {
                                            if (isSelected == false) {
                                                setSelectedCategory(item);
                                                setDistCatParams({
                                                    categoryId: item.id,
                                                });
                                            }


                                        }}  ></DistributionCategoryListItem>
                                    }}
                                />
                            </div>
                        </div>
                        <div style={flex.flexFill}>
                            {selectedCategory != null && (
                                <Fragment>
                                    <RecipientDialog category={selectedCategory} selected={selectedRecipient} show={showRecipientDialog}
                                        onExistingRecipientSelected={(recipient) => {

                                            setShowRecipientDialog(false);
                                            linkRecipient(recipient);
                                        }}
                                        onClose={(didUpdate) => {
                                            if (didUpdate) setDistCatParams({ ...distCatParams });
                                            setShowRecipientDialog(false);
                                        }}></RecipientDialog>

                                    <PagedDataView<IDistributionList, Distribution>
                                        apiHook={api.hooks.distribution.list}
                                        parameters={distCatParams}

                                        renderItem={(item) => {
                                            return <DistributionListItem item={item} onEdit={() => {
                                                setSelectedRecipient(item);
                                                setShowRecipientDialog(true);
                                            }}   ></DistributionListItem>
                                        }}
                                    ><div style={{ padding: 20 }}>{t("editable.noRecipients")}</div></PagedDataView>
                                </Fragment>
                            )}


                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        setShowDialog(false);
                    }}>Close</Button>

                    {(selectedCategory != null && props.manageOnly != true) && (
                        <Button onClick={() => {
                            setShowDialog(false);
                            props.onChange(selectedCategory);
                        }}>Use Selected List</Button>
                    )}
                </DialogActions>
            </Dialog>
            <div style={{ paddingBottom: 5, fontSize: 12, color: "rgb(184, 156, 160)", display: "inline-block" }}>{props.label}</div>
            <br />
            <Button data-testid={props.testId} style={{ minWidth: 200 }} onClick={() => {
                setShowDialog(true);
            }} variant="outlined" color={props.manageOnly ? "secondary" : "primary"} ><b>{props.manageOnly ? t("editable.manage") : fieldText}</b></Button>


        </div>
    );
}

export default DistributionListField;